import nativeBridge from '@ifit/native-webview-interface';
import { Theme } from '@ifit/themes/ThemeContext';
import 'core-js/features/array';
import 'core-js/features/object';
import 'core-js/features/string';
import React from 'react';
import ReactDOM from 'react-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import App from './components/app';
import * as serviceWorker from './serviceWorker';
import getStore from './store';
import handlers from './store/handlers';
import { showNativeCall, showWebviewCall } from './store/verbose-webview';
import { startupDatadog } from './helpers/datadog-init';

import {
  CoreInfo,
  DeviceInfo,
} from '@ifit/native-webview-interface/out/good-cop-keys';

const webviewControlsBackNav = 'WebviewControlsBackNav';

function startApp(): void {
  // just a test
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        staleTime: 300000, // 5 mins
      },
    },
  });
  nativeBridge.initNativeCalls(getStore(), handlers);

  nativeBridge.on('callNative', showWebviewCall);
  nativeBridge.on('callJavaScript', showNativeCall);
  nativeBridge.callNative({ methodName: webviewControlsBackNav });

  if (window.NODE_ENV !== 'development') {
    startupDatadog(window.NODE_ENV);
  }

  ReactDOM.render(
    <Provider store={getStore()}>
      <QueryClientProvider client={queryClient}>
        <Theme>
          <App />
        </Theme>
        <ToastContainer
          className="toast-container"
          newestOnTop={true}
          pauseOnFocusLoss={false}
        />
      </QueryClientProvider>
    </Provider>,
    document.getElementById('root'),
  );

  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: http://bit.ly/CRA-PWA
  serviceWorker.register();
}

function doDebugInitialization(callJavaScript?): void {
  if (!callJavaScript && window && window.callJavaScript) {
    callJavaScript = window.callJavaScript;
  }

  try {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const env = require('./env');
    if (env.skipDebugInitialization) {
      return;
    }

    callJavaScript({
      methodName: 'InitializeApp',
      ...env.appConfig,
    });

    setImmediate(() => {
      callJavaScript({
        methodName: 'DataAvailable',
        [CoreInfo.SelectedSoftwareNumber]: env.appConfig.softwareNumber,
        [CoreInfo.LastKnownConsoleType]: env.appConfig.consoleType,
        [DeviceInfo.DeviceType]: env.appConfig.deviceType,
        'featureflag://show-modality-selector': false,
        echo: `modality-${window.location.host}-1`,
      });
      if (window.location.href.includes('/search')) {
        window.callNative({ methodName: 'hideModality' });
      }
    });
  } catch (err) {
    console.error('Could not load env.ts file:', err);
    console.error('Did you copy src/env.example.ts to src/env.ts?');
  }
}

startApp();
if (
  window.NODE_ENV === 'development' &&
  window.REACT_APP_SKIP_DEBUG_INITIALIZATION !== 'true'
) {
  doDebugInitialization();
}
